import { Instagram, Facebook, Youtube } from "lucide-react";

// Official Seven Pillars social handles
export const SOCIAL_LINKS = {
  instagram: "https://instagram.com/7pillarsoflifetherapy",
  tiktok: "https://www.tiktok.com/@7pillarsoflifetherapy",
  facebook: "https://www.facebook.com/7pillarsoflifetherapy",
  youtube: "https://www.youtube.com/@7pillarsoflifetherapy",
};

// Inline TikTok SVG (lucide-react does not ship a TikTok icon)
function TikTokIcon({ size = 18, strokeWidth = 1.5, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
    </svg>
  );
}

export default function SocialIcons({
  size = 18,
  variant = "default", // "default" | "compact"
  className = "",
}) {
  const items = [
    {
      key: "instagram",
      label: "Instagram",
      href: SOCIAL_LINKS.instagram,
      icon: <Instagram size={size} strokeWidth={1.5} />,
    },
    {
      key: "tiktok",
      label: "TikTok",
      href: SOCIAL_LINKS.tiktok,
      icon: <TikTokIcon size={size} strokeWidth={1.6} />,
    },
    {
      key: "facebook",
      label: "Facebook",
      href: SOCIAL_LINKS.facebook,
      icon: <Facebook size={size} strokeWidth={1.5} />,
    },
    {
      key: "youtube",
      label: "YouTube",
      href: SOCIAL_LINKS.youtube,
      icon: <Youtube size={size} strokeWidth={1.5} />,
    },
  ];

  return (
    <ul className={`flex items-center gap-3 ${className}`} data-testid={`social-icons-${variant}`}>
      {items.map((s) => (
        <li key={s.key}>
          <a
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            data-testid={`social-${s.key}-link`}
            className={
              variant === "compact"
                ? "inline-flex h-9 w-9 items-center justify-center rounded-full border border-current/30 text-current/80 hover:text-terracotta hover:border-terracotta transition-colors"
                : "inline-flex h-10 w-10 items-center justify-center rounded-full border border-bone/25 text-bone/80 hover:text-terracotta hover:border-terracotta transition-colors"
            }
          >
            {s.icon}
          </a>
        </li>
      ))}
    </ul>
  );
}
